import {SearchAlertCaseConstant} from "../redux_constants/search.case.constant";
import {urlEncoder} from "../redux_actions/cases.action";
import {caseArchiveStatusEnum, caseReadStatusEnum} from "../utils/const";
import {store} from "../helper/store";
import {aclPermissions, hasPermissions} from "../const/ACLPermissions";

export const getNewState = () => {
    const hasPermToViewAllCase = hasPermissions([aclPermissions.view_all_cases])
    return {
        isFetching : true,
        search : '',
        case_assigned : !hasPermToViewAllCase,
        read_status : caseReadStatusEnum.ALL,
        validation_id : '',
        page: 1,
        numPages: 1,
        count: 1,
        ordering : '-case_id',
        type: 'assigned',
        date__gte: '',
        date__lte: '',
        priority: '',
        case_status: '',
        archive_status : caseArchiveStatusEnum.UNARCHIVED,
        patient_folder: '',
        page_size: 15
}}

export const getNewStatePreserveOrdering = () => {
    let newState = getNewState();
    newState.ordering = store.getState().searchCaseReducer.ordering;
    const hasPermToViewAllCase = hasPermissions([aclPermissions.view_all_cases])
    if(hasPermToViewAllCase) {
        newState.case_assigned = false;
    }
    return newState
}

const InitialState = getNewState();

export const searchCaseReducer = ( state = InitialState , action) => {
    var returnableState = {}
    switch(action.type){
        case SearchAlertCaseConstant.CASE_SEARCH_INITIATED:
            returnableState = {
                ...state,
                isFetching : true,
            }
            return returnableState;
        case SearchAlertCaseConstant.CASE_SEARCH_SUCCESS:
            returnableState = {
                ...state,
                isFetching : false,
            }
            return returnableState;
        case SearchAlertCaseConstant.CASE_SEARCH_FAILED:
            returnableState = {
                ...state, 
                err: action.error, 
                isFetching : false,
            }
            return returnableState;
        case SearchAlertCaseConstant.CASE_UPDATE_URL_STATE:
            returnableState = Object.assign({}, action.urlState);
            updateUrl(returnableState);
            return returnableState;
        case SearchAlertCaseConstant.CASE_UPDATE_SEARCHES:
            returnableState = {
                ...state, 
            }
            returnableState.searches = action.searches;
            updateUrl(returnableState);
            return returnableState;
        case SearchAlertCaseConstant.CASE_CHANGE_PAGE:
            returnableState = {
                ...state
            }
            returnableState.page = action.page
            return returnableState;
        default :
            returnableState = state
            return returnableState;
    }
}

export const updateUrl = (state) => {
    var encodedUrl = urlEncoder(state);
    window.history.replaceState(state, 'filter_params', encodedUrl);
}